<template>
  <div v-if="hasValidAsyncStatus && (! hasItem(target) || $slots['default'])"
       class="">
    <div class="width-expand flex-middle flex-center" v-if="shouldShowSpinner">
      <spinner v-bind="spinnerProps"></spinner>
     </div>

    <div class="no-content" v-if="shouldShowNoItems">
        <slot name="no-data">
          <h3>
            {{isList ? tu('core.noItemsFound') : tu('core.noItemFound')}}
          </h3>
        </slot>
      </div>

    <div class="animate__fadeIn animate--fast"  v-if="! shouldShowSpinner &&  hasItem(target) && $slots['default']">
      <slot name="default"></slot>
    </div>

  </div>
</template>

<script>
export default {
  props: {
    // specifically can be anything

    // eslint-disable-next-line vue/require-default-prop
    target: {},
    spinnerProps: {
      type: Object,
      default: {
        size: 6,
        text: "core.loading",
        textSize: "2xl",
      },
    },
    asyncStatus: {
      type: Object,
      default: () => {},
    },
    hasItem: {
      type: Function,
      default: (item) => {
        if (!item) {
          return false;
        }

        if (Array.isArray(item) && item.length < 1) {
          return false;
        }

        if (typeof item === "object" && Object.keys.length < 1) {
          return false;
        }

        return true;
      },
    },
    isList: {
      type: Boolean,
      default: false,
    }
  },
  data: function () {
    return {
      hasResult : false,
    };
  },
  computed: {
    hasValidAsyncStatus() {
      return utilities.hasOwnProperty(this.asyncStatus, 'loading');
    },
    shouldShowSpinner() {
      return this.asyncStatus.asyncDataLoading;
    },
    shouldShowNoItems() {
      return ! this.shouldShowSpinner && ! this.hasItem(this.target)
    }
  },
  watch: {
    target: {
      handler(newVal) {
      //  console.log('target', newVal);
       // this.hasResult =
      },
      deep: true,
    }
  }
};
</script>

<style scoped lang="scss"></style>
